exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trend_table[data-v-c46632cc]  .el-table th .el-checkbox{display:none}.color_box[data-v-c46632cc]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:10px;width:100%;-ms-flex-wrap:wrap;flex-wrap:wrap}.color_box li[data-v-c46632cc]{width:20px;height:20px;border:5px solid transparent;-webkit-box-sizing:content-box;box-sizing:content-box}.color_box li.active[data-v-c46632cc],.color_box li[data-v-c46632cc]:hover{border-color:#1890ff}", ""]);

// exports
